import PropTypes from 'prop-types';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { CHANNEL_LABEL } from 'src/components/outbound/dialerModel';

// Which way to call back (CU-869fn2wcy): only the channels this user can use right now
// (dialerModel.usableChannels). The widget hides it when there is no real choice.
export default function DialerChannelSwitch({ options, value, onChange }) {
    return (
        <ToggleButtonGroup
            exclusive
            fullWidth
            size="small"
            color="primary"
            value={value}
            onChange={(_, next) => { if (next) onChange(next); }}
            aria-label="Call back by"
            data-testid="dialer-channel-switch"
            // The app's global button style capitalises every word; keep sentence case.
            sx={{ '& .MuiToggleButton-root': { textTransform: 'none !important', py: 0.5 } }}
        >
            {options.map((channel) => (
                <ToggleButton key={channel} value={channel} data-testid={`dialer-channel-${channel}`}>
                    {CHANNEL_LABEL[channel] || channel}
                </ToggleButton>
            ))}
        </ToggleButtonGroup>
    );
}

DialerChannelSwitch.propTypes = {
    options: PropTypes.arrayOf(PropTypes.string).isRequired,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
};
DialerChannelSwitch.defaultProps = { value: null };
